import { lazy } from 'react'

export const TargetAreas = lazy(() => import('./v1/TargetAreas'))
export const TargetAreasV2 = lazy(() => import('./v2/TargetAreasV2'))
